import { plainToInstance } from 'class-transformer'
import {
  ISiteBoxDocumentVersionBase,
  SiteBoxDocumentVersionBase,
} from '@core/entities/SiteBoxDocumentVersionBase'
import { FileFormat } from '@core/entities/SiteBoxDocument'

/**
 * A SiteBox document version for any non-PDF format (image, video, Office, CAD).
 * Sibling of `SiteBoxDocumentPdfVersion`: the narrowed `format` literal makes
 * `SiteBoxDocument.currentVersion` a discriminated union that narrows on
 * `format` (PDF vs everything else). Adds no fields beyond the base.
 */
export class SiteBoxDocumentNonPdfVersion extends SiteBoxDocumentVersionBase {
  format: Exclude<FileFormat, 'PDF'>

  public static new(payload: ISiteBoxDocumentVersionBase) {
    return plainToInstance(SiteBoxDocumentNonPdfVersion, payload)
  }
}
